import { jsx as _jsx } from "react/jsx-runtime";
import DashboardIcon from '@mui/icons-material/Dashboard';
import { TreeItem2 } from '@mui/x-tree-view';
import { useNavigate } from 'react-router-dom';
import config from '../../../config';
export const DashboardTree = ({ applicationData, contextCustomer, transactionFunctions, userFunctions, user, roleArbitrationInstance }) => {
    const navigate = useNavigate();
    return (_jsx(TreeItem2, { itemId: "Dashboard", label: 'Dashboard', onClick: () => navigate(config.app.initialRedirect), slots: { endIcon: DashboardIcon } }, 'Dashboard'));
};
